import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getDistanceFromDocumentTop, qsOptional, qsRequired } from '@/scripts/core/global'
import { StickyHeader } from '@/scripts/theme/sticky-header'

export class StickyColumns extends UcoastEl {
	static htmlSelector = 'sticky-columns'
	scrollEl: HTMLElement
	fixedEl: HTMLElement
	disableHeaderScroll: boolean
	stickyHeader: StickyHeader
	stickyEnabled: boolean
	initialAnnouncementHeight: number
	constructor() {
		super()
		this.initialAnnouncementHeight = qsOptional('[data-announcement-bar]')?.getBoundingClientRect().height || 0
		this.stickyEnabled = false
		this.scrollEl = qsRequired('[data-sticky-scroll]', this)
		this.fixedEl = qsRequired('[data-sticky-fixed]', this)
		this.disableHeaderScroll = this.hasAttribute('data-disable-header-scroll')
		this.stickyHeader = qsRequired<StickyHeader>('sticky-header')
		this.onHeaderScrollEvent = this.onHeaderScrollEvent.bind(this)
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop
		if (scrollTop < window.Ucoast.screen.height) {
			this.onHeaderScrollEvent(scrollTop)
			if (window.Ucoast.screen.width >= 990) {
				this.enableSticky()
			}
		}

	}
	onHeaderScrollEvent(scrollTop: number) {
		if (window.Ucoast.screen.width < 990) {
			this.disableSticky(scrollTop)
			return
		}
		const rect = this.scrollEl.getBoundingClientRect();
		const viewportHeight = window.innerHeight;

		if (rect.bottom < viewportHeight) {
			if (this.stickyEnabled) {
				this.disableSticky(scrollTop)
			}
		} else if (!this.stickyEnabled) {
			this.enableSticky()
		}
	}
	enableSticky() {
		this.stickyEnabled = true
		this.fixedEl.setAttribute('data-sticky-fixed', 'on')
		this.fixedEl.removeAttribute('style')
		if (this.disableHeaderScroll) {
			this.stickyHeader.preventHide = true
		}
	}
	disableSticky(scrollTop: number) {
		this.stickyEnabled = false
		this.fixedEl.setAttribute('data-sticky-fixed', 'off')
		this.fixedEl.style.top = `${getDistanceFromDocumentTop(this.fixedEl, scrollTop) + scrollTop}px`
		if (this.disableHeaderScroll) {
			this.stickyHeader.preventHide = false
		}
	}
}
